import { Link, navigate } from 'gatsby'
import React, { useEffect } from 'react'
import * as ContactUserStyles from './index.module.scss'
import { ContactPageTitle } from '@/components/contact/contact-page-title'
import { ServicePointContainer } from '@/components/contact/service-point-container'
import { ContactForm } from '@/components/form/contact-form'
import { Layout } from '@/components/general/layout'
import { Seo } from '@/components/general/seo'
import { pagesPath } from '@/lib/pagesPath'
import { useFormStorage } from '@/lib/use-form-storage'
import * as Styles from '@/pages/contact/index.module.scss'

const ContactUserPage = ({ location }) => {
  const { getFormStorage, setFormStorage, cleanFormStorage } = useFormStorage()
  const formState = getFormStorage()

  useEffect(() => {
    if (formState) {
      return () => cleanFormStorage()
    }
  }, [])
  return (
    <Layout location={location}>
      <Seo
        title="ご契約者様専用のお問い合わせ"
        meta={[
          {
            name: 'robots',
            content: 'noindex, nofollow',
          },
          {
            name: 'googlebot',
            content: 'noindex, nofollow',
          },
        ]}
      />
      <ContactPageTitle
        title="ご契約者様専用のお問い合わせ"
        en="CONTACT"
        readText={
          <div className={Styles.readText}>
            ご契約いただいているサービスに関する
            <br className="sp" />
            お問い合わせフォームとなります。
            <br />
            Uniforceの使い方については「
            <Link
              to="https://uniforce-cloud.notion.site/7c05ba6518f74aa69faa4329ff5210ab"
              target="_blank"
              rel="noopener noreferrer"
            >
              使い方ガイド
            </Link>
            」もご参照ください。
            <br />
            <span>サービスの導入をご検討</span>されているお客様は
            <Link to={pagesPath.contact.$url()}>こちら</Link>。
          </div>
        }
        className={ContactUserStyles.contactUserPageTitle}
      />

      <div className={Styles.container}>
        <ContactForm
          className={Styles.form}
          initFormState={{
            ...formState,
            contract: 'サービス契約中',
            agree_flag: false,
          }}
          submitHandler={async (state) => {
            setFormStorage(state)
            await navigate(pagesPath.contactUser.confirmation.$url())
          }}
        />
        <ServicePointContainer />
      </div>
    </Layout>
  )
}

export default ContactUserPage
